import { useRef, useState } from 'react';
import { useRouter } from 'next/router';
import { ModelReviewsInterface } from 'types/Apis/SearchURL';
import { fetchModelReviews } from 'lib/AutolistAPI';
import ReviewsLayout from '../Reviews/ReviewsLayout';
import AggregateCard from './AggregateCard';
import OwnerReview from './OwnerReview';
import Pagination from './Pagination';

interface OwnerReviewsProps {
  reviews: ModelReviewsInterface;
  pageType: string;
  header?: string;
}

export default function OwnerReviews({
  reviews,
  header,
  pageType = '',
}: OwnerReviewsProps): JSX.Element {
  const [currentPage, setCurrentPage] = useState(reviews.pagination.currentPage);
  const router = useRouter();
  const { query } = router;
  const [ownerReviews, setOwnerReviews] = useState(reviews.ownerReviews);
  const layoutScrollRef = useRef<HTMLDivElement>(null);

  const fetchOwnerReviews = async (page: number): Promise<void> => {
    const ownerReviewsRes = await fetchModelReviews(
      query.parentPage as string,
      pageType,
      page.toString()
    );
    if (ownerReviewsRes) {
      setOwnerReviews(ownerReviewsRes.ownerReviews);
    }

    if (layoutScrollRef?.current && page >= 1) {
      layoutScrollRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <>
      <div ref={layoutScrollRef}>
        <ReviewsLayout
          header={header}
          summary={<AggregateCard reviewSummary={reviews.ownerReviewSummary} />}
          reviews={
            <>
              {ownerReviews.map((review) => (
                <OwnerReview review={review} key={review.id} />
              ))}
            </>
          }
          pagination={
            <Pagination
              currentPage={currentPage}
              onPageChange={(page): void => {
                setCurrentPage(page);
                fetchOwnerReviews(page);
              }}
              pageCount={reviews.pagination.totalPages}
            />
          }
        />
      </div>
    </>
  );
}
